import { SupportTicketMapper } from '../SupportTicketMapper.js';
import { SupportTicketClaimDataMapper } from '../SupportTicketClaimData/SupportTicketClaimDataMapper.js';

/**
 * Plain object Packlink's API response representation.
 */

class LossSupportTicketMapper {
  static createModelFromResponse(response) {
    return {
      ...SupportTicketMapper.createModelFromResponse(response),
      ...SupportTicketClaimDataMapper.createModelFromResponse(response.loss),
      shipmentReference: response.shipment_reference
    };
  }
  static createApiPayload(_ref) {
    let {
      shipmentReference,
      amount,
      proofOfValue,
      productDescription,
      paymentMethod
    } = _ref;
    return {
      shipment_reference: shipmentReference,
      loss: SupportTicketClaimDataMapper.createApiPayload({
        amount,
        proofOfValue,
        productDescription,
        paymentMethod
      })
    };
  }
}

export { LossSupportTicketMapper };
//# sourceMappingURL=LossSupportTicketMapper.js.map
